import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import UserBadgeSash from 'src/apps/People/components/UserBadgeSash'

const UserListItem = ({
   action,
   avatarMedia,
   badges,
   borderTop,
   fullName,
   organization,
   position,
   status
}) => {
   const avatarUrl = avatarMedia
      ? avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <View
         display="flex"
         alignItems="center"
         float="left"
         width="100%"
         padding="10px 0px"
         borderTop={borderTop}>
         <View
            flex="0 0 auto"
            width="24px"
            height="24px"
            borderRadius="3px"
            backgroundColor="#ddd"
            backgroundImage={`url(${avatarUrl})`}
            backgroundSize={avatarMedia ? 'cover' : '21px 21px'}
            backgroundPosition="bottom center"
            style={{
               backgroundRepeat: 'no-repeat'
            }}
         />
         <View flex="1 1 auto" padding="0 15px">
            <View display="flex" alignItems="center">
               <Text size="2" color="#111" weight="medium">
                  {fullName}
               </Text>
               <UserBadgeSash badges={badges} style={{ margin: '0px 10px' }} />
            </View>
            <Text size="1" color="#aaa" weight="normal">
               {position}
               {organization}
            </Text>
         </View>
         {['active', 'invited'].includes(status) && (
            <View flex="0 0 auto">
               {action}
            </View>
         )}
      </View>
   )
}

UserListItem.propTypes = {
   action: PropTypes.node,
   avatarMedia: PropTypes.object,
   badges: PropTypes.array,
   borderTop: PropTypes.string,
   fullName: PropTypes.string.isRequired,
   organization: PropTypes.string,
   position: PropTypes.string,
   status: PropTypes.string.isRequired
}

UserListItem.defaultProps = {
   action: undefined,
   avatarMedia: undefined,
   badges: [],
   borderTop: '1px solid #eee',
   organization: undefined,
   position: undefined
}

export default React.memo(UserListItem)
